import { initPostHog } from "@alascorporation/observability";
import posthog from "posthog-js";

initPostHog(posthog, {
  apiKey: import.meta.env.VITE_POSTHOG_KEY,
  host: import.meta.env.VITE_POSTHOG_HOST,
  env: import.meta.env,
});

export { posthog };
